export function getIsMobileDevice(): boolean {
  if (navigator.userAgent) {
    return /(android|ipad|iphone|windows phone)/i.test(navigator.userAgent)
  }

  return false
}
